export const round2 = (n: number) => Math.round((n + Number.EPSILON) * 100) / 100

export const toMoney = (v: unknown): number => {
  if (typeof v === 'number') return Number.isFinite(v) ? v : 0
  if (typeof v !== 'string') return 0

  const s = v.trim()
  if (!s) return 0

  // handle parentheses for negatives, e.g. "(1,234.56)"
  const negParen = s.startsWith('(') && s.endsWith(')')

  // strip everything except digits, minus and dot
  const cleaned = s.replace(/[^0-9.-]+/g, '')
  const n = Number(cleaned)

  if (!Number.isFinite(n)) return 0
  return negParen ? -Math.abs(n) : n
}
